import { secondaryText, Theme } from 'features/Theme';
import { css, SerializedStyles } from '@emotion/core';

const styles = {
  card: (theme: Theme): SerializedStyles => css`
    border: 1px solid ${theme.mui.palette.divider};
  `,
  optInOutText: (theme: Theme): SerializedStyles => css`
    &,
    p {
      ${secondaryText(theme)};
      text-align: left;
    }
    margin-bottom: ${theme.mui.spacing(1)}px;
  `,
  optInOutLabel: (theme: Theme): SerializedStyles => css`
    .MuiFormControlLabel-label {
      ${secondaryText(theme)};
    }
  `,
};
export default styles;
